import React from 'react'
import { connect } from 'react-redux'
import { PlainList } from 'components/Layout'
import {
	submissionListRequest,
	submissionCancelRequest,
	submissionCreateRequest
} from '../../actions'
import { OpenChatButton } from 'components/Button'
import { BoxShell } from 'components/Shells'
import { ButtonLoader } from 'components/Loader'

import { RequestSubmissionButton, CancelSubmissionButton } from '../Buttons'

class SubmissionListContainer extends React.Component {
	componentWillMount() {
		this.props.submissionListRequest()
	}
	render() {
		const {
			submissions,
			isAppInDevelopment,
			submissionCancelRequest,
			submissionCreateRequest
		} = this.props

		if (typeof submissions === 'undefined') {
			return (
				<BoxShell dark height={120}>
					<ButtonLoader />
				</BoxShell>
			)
		}

		return (
			<PlainList
				header={'Submission history'}
				footer={
					Object.keys(submissions).length > 5
						? 'We show last five submissions.'
						: null
				}
				emptyState={
					<span>
						You haven't submitted this app yet.<br />Seems like a
						perfect time to do it now!
					</span>
				}
				elements={Object.keys(submissions)
					.slice(0, 5)
					.map((submission, i) => {
						const meta = submissions[submission]

						const updatedAt = new Date(
							meta.updatedAt !== 0
								? meta.updatedAt * 1000
								: meta.createdAt * 1000
						)
						const updatedAtString = updatedAt.toLocaleDateString()
						const status = meta.status

						switch (status) {
							case 'NEW':
								return {
									id: submission,
									title: 'Submission is pending review',
									footer: (
										<CancelSubmissionButton
											label={'Cancel'}
											handleCancel={
												submissionCancelRequest
											}
											submission={submission}
										/>
									),
									desc: (
										<span>
											<p
												style={{
													marginRight: '10px',
													align: 'flex-start',
													textAlign: 'left',
													fontSize: '12px',
													letterSpacing: '.02em'
												}}
											>
												ID: {meta.id}
											</p>
											<p>
												Our team will process this
												submission as quickly as
												possible. It usually takes up to
												7 work days to finish the review
												process. Thank you for your
												patience!
											</p>
										</span>
									),
									info: `Created at ${updatedAtString}`
								}
							case 'REMOVED':
								return {
									id: submission,
									title: 'Submission was canceled by you',
									info: `${updatedAtString}, Canceled at ${updatedAtString}`
								}
							case 'ACCEPTED':
								return {
									id: submission,
									title: 'Submission was accepted',
									desc: (
										<span>
											Hooray! 🎉 Your submission is
											accepted. You can now publish the
											app!
										</span>
									),
									info: `Accepted at ${updatedAtString}`
								}
							case 'REJECTED':
								return {
									id: submission,
									title: 'Submission was rejected',
									desc: (
										<span>
											<p>
												We're sorry – your submission
												was rejected. The reason should
												be listed below. If you have any
												questions or doubts feel free to
												contact us anytime.
											</p>
											{meta.message
												? <p>
														<i>
															Reason:{' '}
															{meta.message || 'Not provided.'}
														</i>
													</p>
												: null}
										</span>
									),
									footer: (
										<OpenChatButton label={'Contact us'} />
									),
									info: `Rejected at ${updatedAtString}`
								}
							default:
								return null
						}
					})}
				info={
					isAppInDevelopment
						? <RequestSubmissionButton
								label={'Submit to review'}
								handleRequest={submissionCreateRequest}
							/>
						: null
				}
			/>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const currentAppId = ownProps.appId
	const currentApp = state.apps.items[currentAppId]

	const isAppPublished = currentApp
		? currentApp.status === 'PUBLISHED'
		: false
	const isAppInDevelopment = currentApp
		? currentApp.status === 'IN_DEVELOPMENT'
		: false
	const isAppAccepted = currentApp ? currentApp.status === 'ACCEPTED' : false

	return {
		submissions:
			state.submissions && Object.keys(state.submissions.items).length > 0
				? state.submissions.items[currentAppId]
				: null,
		isAppPublished,
		isAppAccepted,
		isAppInDevelopment
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	submissionListRequest: () => {
		dispatch(submissionListRequest({ id: ownProps.appId }))
	},
	submissionCancelRequest: submissionId => {
		dispatch(
			submissionCancelRequest({ id: submissionId, appId: ownProps.appId })
		)
	},
	submissionCreateRequest: () => {
		dispatch(submissionCreateRequest({ appId: ownProps.appId }))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(
	SubmissionListContainer
)



// WEBPACK FOOTER //
// ./src/containers/SubmissionList/SubmissionList.js